import { Extension } from '@tiptap/core';

const INDENT = '    ';

function insertIndent(editor) {
  return editor.chain().focus().insertContent(INDENT).run();
}

function removeIndentBeforeCursor(editor) {
  const { selection, doc } = editor.state;
  const pos = selection.$from.pos;
  const from = Math.max(0, pos - INDENT.length);
  if (doc.textBetween(from, pos) === INDENT) {
    return editor.chain().focus().deleteRange({ from, to: pos }).run();
  }
  return false;
}

/**
 * Keeps Tab / Shift-Tab inside the editor: nests list items, indents paragraphs,
 * and prevents the browser from moving focus to the page toolbar.
 */
const TabHandler = Extension.create({
  name: 'tabHandler',

  priority: 1000,

  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => {
        if (editor.isActive('codeBlock')) {
          editor.chain().focus().insertContent('\t').run();
          return true;
        }

        if (editor.isActive('listItem')) {
          if (editor.chain().focus().sinkListItem('listItem').run()) {
            return true;
          }
        }

        insertIndent(editor);
        return true;
      },

      'Shift-Tab': ({ editor }) => {
        if (editor.isActive('listItem')) {
          if (editor.chain().focus().liftListItem('listItem').run()) {
            return true;
          }
        }

        removeIndentBeforeCursor(editor);
        return true;
      },
    };
  },
});

export default TabHandler;
